/**
 * Order grid baised on window width
 */

const breakpoints = {
    "tablet" : 992,
    "mobile" : 575,
}

// [current index, new index]
const changes = {
    "desktop" : [[1, 3], [2, 4]],
    "tablet" : [[1, 3], [2, 1], [3, 4], [4, 2]]
}

class ReorderGrid {

    constructor (element) {
        if(!(element instanceof HTMLElement)) {
			throw new TypeError('Invalid element');
        }

        this.grid = element;
        this.grid.cols = Array.from(this.grid.querySelectorAll('[class*=grid__col-]')).filter( col => col.children[0].tagName == 'A');

        this.currentOrder = 'mobile';

        this.reorderGrid();

        window.addEventListener('resize', () => {
            this.reorderGrid();
        });
    }

    reorderGrid() {
        let viewWidth = window.innerWidth;
        let currentOrder = this.currentOrder;

        if (viewWidth >= breakpoints.tablet) {
            if (currentOrder != 'desktop') {
                if (currentOrder === 'tablet') {
                    this.unorderTablet();
                }
                this.orderDesktop();
            }
        } else if (viewWidth < breakpoints.mobile) {
            if (currentOrder != 'mobile') {
                if (currentOrder === 'desktop') {
                    this.unorderDesktop();
                } else {
                    this.unorderTablet();
                }
            }
        } else if (viewWidth < breakpoints.tablet) {
            if (currentOrder != 'tablet') {
                if (currentOrder === 'desktop') {
                    this.unorderDesktop();
                }
                this.orderTablet();
            }
        }

        // console.log(`new order: ${this.currentOrder}`);
    }

    // TODO: general reorder function using orderTablet implementaion
    orderDesktop () {
        let moves = changes.desktop;

        moves.forEach( current => {
            // get the elements to swap
            let a = this.grid.cols[current[0]];
            let b = this.grid.cols[current[1]];

            try {
                a.content = a.firstElementChild;
                b.content = b.firstElementChild;
                a.insertAdjacentElement('beforeend', b.content);
                b.insertAdjacentElement('beforeend', a.content);
            } catch (error) {
                console.error(error);
            }
        });

        this.currentOrder = 'desktop';
    }

    unorderDesktop () {
        // As desktop works as a stright swap,
        // the same function can be used to undo the swap.
        this.orderDesktop();

        this.currentOrder = 'mobile';
    }

    orderTablet () {
        let moves = changes.tablet;

        for (let i = 0; i < moves.length; i++) {
            let innerElement = this.grid.cols[moves[i][0]].firstElementChild;
            let outerElement = this.grid.cols[moves[i][1]];

            outerElement.insertAdjacentElement('beforeend', innerElement);

        }

        this.currentOrder = 'tablet';
    }

    unorderTablet () {
        let moves = changes.tablet;

        for (let i = moves.length - 1; i >= 0; i--) {
            let innerElement = this.grid.cols[moves[i][1]].firstElementChild;
            let outerElement = this.grid.cols[moves[i][0]];

            outerElement.insertAdjacentElement('beforeend', innerElement);
        }

        this.currentOrder = 'mobile';
    }
}

export default ReorderGrid;
